import { MenuItem } from '@app/shared/models/menu.model';
import { animate } from '@angular/animations';

export const MENU_ITEMS: MenuItem[] = [
  { icon: 'lines', link: '/', label: 'Lineas', style: 'transform: scale(1.0)' },
  // {
  //   icon: 'notace',
  //   link: '/notices',
  //   label: 'Avisos',
  //   style: 'transform: scale(1.3)',
  // },
  // {
  //   icon: 'fares',
  //   // href: 'https://transviago.com/tarifas-fernanbus/',
  //   link: '/rates',
  //   label: 'Tarifas',
  //   style: 'transform: scale(1.5)',
  // },
  { icon: 'stops', event: true, label: 'Paradas', style: 'transform: scale(1.2)' },
  { icon: 'favorites', link: '/favorites', label: 'Favoritas',  style: 'transform: scale(1.2)' },
];
